import { resolveUserId } from '~/utils/analytics/user-id';

export default ({ store }, inject) => {
  // GTM is now loaded via manual script, so we don't need to check env.GTM_ID
  const dataLayerPush = async (eventName, newData) => {
    if (!window.dataLayer) {
      window.dataLayer = [];
    }

    // El usuario se relee aca, no al cargar el plugin: cuando el plugin corre
    // todavia no hay sesion (VEX-6458). La clave viaja siempre, incluso en
    // undefined, para limpiar el modelo del dataLayer al desloguear.
    window.dataLayer.push({
      event: eventName,
      data: newData,
      user_id: resolveUserId(store.state.auth.user, newData)
    });
    return;
  };

  dataLayerPush({ data: null });

  inject('dataLayerPush', dataLayerPush);
};
